export const translations = {
  seo: {
    guidePage: {
      it: { title: "Guida gratuita Incoterms 2020 in PDF — LB Trade Advisory", desc: "Scarica gratis la guida pratica agli Incoterms 2020: gli 11 termini spiegati, chi paga trasporto, assicurazione e dogane, i 5 errori più costosi e la checklist in 6 domande." },
      en: { title: "Free Incoterms 2020 PDF Guide — LB Trade Advisory", desc: "Download the free practical guide to Incoterms 2020: the 11 terms explained, who pays for transport, insurance and customs, the 5 costliest mistakes and a 6-question checklist." }
    },
    home: {
      it: { title: "LB Trade Advisory — Better decisions in international trade", desc: "Consulenza import-export: conoscenza, soluzioni e fiducia per decisioni migliori nel commercio internazionale." },
      en: { title: "LB Trade Advisory — Better decisions in international trade", desc: "Import-export advisory: knowledge, solutions and trust for better decisions in international trade." }
    },
    about: {
      it: { title: "Chi siamo — LB Trade Advisory", desc: "La storia, l'approccio, il metodo e i valori di LB Trade Advisory." },
      en: { title: "About — LB Trade Advisory", desc: "The story, approach, method and values of LB Trade Advisory." }
    },
    knowledge: {
      it: { title: "Knowledge Center — LB Trade Advisory", desc: "Guide pratiche su Incoterms, dogane, logistica e spedizioni internazionali." },
      en: { title: "Knowledge Center — LB Trade Advisory", desc: "Practical guides on Incoterms, customs, logistics and international shipments." }
    },
    insights: {
      it: { title: "Insights — LB Trade Advisory", desc: "Approfondimenti su mercati esteri, contratti internazionali e catene di fornitura." },
      en: { title: "Insights — LB Trade Advisory", desc: "In-depth analysis on foreign markets, international contracts and supply chains." }
    },
    contact: {
      it: { title: "Contatti — LB Trade Advisory", desc: "Raccontaci il tuo progetto: ti risponderemo con concretezza." },
      en: { title: "Contact — LB Trade Advisory", desc: "Tell us about your project: we will reply with substance." }
    },
    admin: {
      it: { title: "Area riservata — LB Trade Advisory", desc: "Area amministrativa riservata." },
      en: { title: "Reserved area — LB Trade Advisory", desc: "Reserved administration area." }
    },
    article: {
      it: { title: "Articolo — LB Trade Advisory", desc: "Approfondimento LB Trade Advisory." },
      en: { title: "Article — LB Trade Advisory", desc: "LB Trade Advisory insight." }
    },
    notfound: {
      it: { title: "Pagina non trovata — LB Trade Advisory", desc: "La pagina richiesta non esiste." },
      en: { title: "Page not found — LB Trade Advisory", desc: "The requested page does not exist." }
    }
  },

  nav: {
    it: { about: "Chi siamo", advisory: "Consulenza", knowledge: "Knowledge Center", insights: "Insights", contact: "Contatti", admin: "Area riservata" },
    en: { about: "About", advisory: "Advisory", knowledge: "Knowledge Center", insights: "Insights", contact: "Contact", admin: "Reserved area" }
  },

  guide: {
    it: {
      eyebrow: "Guida gratuita — PDF",
      title: "Incoterms 2020: scegli il termine giusto, proteggi la spedizione.",
      subtitle: "La guida pratica di 4 pagine per chi esporta e importa: gli 11 termini senza legalese, chi paga trasporto, assicurazione e dogane, e gli errori che costano caro.",
      bullets: [
        "Scarichi subito il PDF, nessuna attesa",
        "Tabelle chiare: chi risponde di trasporto, assicurazione e dogane",
        "I 5 errori più costosi (e come evitarli)",
        "La checklist in 6 domande prima di firmare il contratto"
      ],
      trust: "Solo la tua email, zero spam: disiscrizione con un click",
      coverTagline: "Costi, rischi e obblighi tra venditore e acquirente, spiegati senza legalese.",
      coverItems: ["11 termini", "Costi e rischi", "5 errori", "Checklist"],
      insideTitle: "Dentro la guida",
      inside: [
        { t: "Che cosa sono gli Incoterms (e che cosa non sono)", d: "Il ruolo dei termini nel contratto: passaggio di rischio, costi e obblighi — e i due malintesi più comuni." },
        { t: "Gli 11 termini in un colpo d'occhio", d: "Da EXW a DDP: quando si usa ciascuno, con esempi concreti di export su strada e via mare." },
        { t: "Chi risponde di che cosa", d: "La tabella che incrocia trasporto, assicurazione e dogane per ogni termine: il quadrato da tenere in azienda." },
        { t: "I 5 errori che costano caro + checklist", d: "EXW \"per prudenza\", FOB vs FCA sui container, DDP senza calcoli: e le 6 domande da farsi prima di scegliere." }
      ],
      authorBlurb: "Una guida di LB Trade Advisory: dogane, Incoterms e spedizioni internazionali sono il lavoro di tutti i giorni, non la teoria di un manuale.",
      formTitle: "Dove ti spediamo la guida?",
      formSub: "Inserisci la tua email: ricevi subito il link per scaricare il PDF.",
      nameLabel: "Nome (facoltativo)",
      namePlaceholder: "Il tuo nome",
      emailLabel: "Email aziendale",
      consent: "Acconsento a ricevere la guida e la newsletter di LB Trade Advisory (articoli e guide sul commercio internazionale, una ogni tanto). Posso cancellarmi in qualsiasi momento.",
      submit: "MANDAMI LA GUIDA",
      noSpam: "Niente spam. Disiscrizione con un click.",
      successTitle: "Fatto! La guida è in arrivo",
      successText: "Ti abbiamo appena inviato l'email con il link per scaricare il PDF. Controlla la casella (e lo spam, nel caso).",
      downloadBtn: "SCARICA ORA",
      confirmNote: "Nell'email trovi anche il link per confermare l'iscrizione alla newsletter: riceverai i prossimi articoli e guide, una ogni tanto.",
      errConsent: "Inserisci l'email e spunta il consenso per continuare.",
      errGeneric: "Qualcosa non ha funzionato. Riprova tra poco.",
      banner: "Guida gratuita: Incoterms 2020 (PDF)"
    },
    en: {
      eyebrow: "Free guide — PDF",
      title: "Incoterms 2020: choose the right term, protect the shipment.",
      subtitle: "The practical 4-page guide for exporters and importers: the 11 terms without legalese, who pays for transport, insurance and customs, and the mistakes that cost the most.",
      bullets: [
        "Download the PDF right away, no waiting",
        "Clear tables: who answers for transport, insurance and customs",
        "The 5 most expensive mistakes (and how to avoid them)",
        "The 6-question checklist before signing the contract"
      ],
      trust: "Just your email, zero spam: unsubscribe in one click",
      coverTagline: "Costs, risks and obligations between seller and buyer, explained without legalese.",
      coverItems: ["11 terms", "Costs & risks", "5 mistakes", "Checklist"],
      insideTitle: "Inside the guide",
      inside: [
        { t: "What Incoterms are (and what they are not)", d: "The role of the terms in the contract: transfer of risk, costs and obligations — and the two most common misunderstandings." },
        { t: "The 11 terms at a glance", d: "From EXW to DDP: when to use each, with concrete road and sea export examples." },
        { t: "Who is responsible for what", d: "The table crossing transport, insurance and customs for every term: the grid to keep at the office." },
        { t: "The 5 costly mistakes + checklist", d: "EXW \"to be safe\", FOB vs FCA on containers, DDP without the math: and the 6 questions to ask before choosing." }
      ],
      authorBlurb: "A guide by LB Trade Advisory: customs, Incoterms and international shipping are our daily job, not textbook theory.",
      formTitle: "Where should we send the guide?",
      formSub: "Enter your email: you get the PDF download link right away.",
      nameLabel: "Name (optional)",
      namePlaceholder: "Your name",
      emailLabel: "Business email",
      consent: "I agree to receive the guide and the LB Trade Advisory newsletter (articles and guides on international trade, from time to time). I can unsubscribe at any time.",
      submit: "SEND ME THE GUIDE",
      noSpam: "No spam. Unsubscribe in one click.",
      successTitle: "Done! Your guide is on its way",
      successText: "We just sent you the email with the PDF download link. Check your inbox (and your spam folder, just in case).",
      downloadBtn: "DOWNLOAD NOW",
      confirmNote: "The email also contains the link to confirm your newsletter subscription: you'll receive future articles and guides, one at a time.",
      errConsent: "Enter your email and tick the consent box to continue.",
      errGeneric: "Something went wrong. Please try again shortly.",
      banner: "Free guide: Incoterms 2020 (PDF)"
    }
  },

  common: {
    it: {
      readArticle: "Leggi l'articolo", all: "Tutti", back: "Torna indietro", loading: "Caricamento…",
      minRead: "min di lettura", related: "Approfondimenti correlati", knowledgeLabel: "Knowledge Center",
      insightsLabel: "Insights", noArticles: "Nessun articolo pubblicato per ora. Torna presto.",
      noResults: "Nessun articolo trovato con questi criteri.",
      catEyebrow: "Articoli per categoria", exploreCategories: "Esplora per categoria", viewArticles: "Vedi articoli",
      share: "Condividi", copyLink: "Copia link", linkCopied: "Link copiato!", followPage: "Segui la pagina",
      linkedinTitle: "Seguici anche su LinkedIn",
      linkedinText: "Ogni venerdì pubblichiamo il consiglio pratico della settimana: dogane, dazi, Incoterms e logistica in un post da un minuto.",
      searchPlaceholder: "Cerca un tema… (es. dazi, FCA, spedizioni)",
      guideEyebrow: "Guida gratuita — PDF", guideBanner: "Incoterms 2020: scegli il termine giusto", guideCta: "Scarica"
    },
    en: {
      readArticle: "Read the article", all: "All", back: "Back", loading: "Loading…",
      minRead: "min read", related: "Related insights", knowledgeLabel: "Knowledge Center",
      insightsLabel: "Insights", noArticles: "No published articles yet. Come back soon.",
      noResults: "No articles match these filters.",
      catEyebrow: "Articles by category", exploreCategories: "Explore by category", viewArticles: "View articles",
      share: "Share", copyLink: "Copy link", linkCopied: "Link copied!", followPage: "Follow the page",
      linkedinTitle: "Follow us on LinkedIn too",
      linkedinText: "Every Friday we publish the week's practical tip: customs, duties, Incoterms and logistics in a one-minute post.",
      searchPlaceholder: "Search a topic… (e.g. duties, FCA, shipping)",
      guideEyebrow: "Free guide — PDF", guideBanner: "Incoterms 2020: choose the right term", guideCta: "Download"
    }
  },

  home: {
    it: {
      eyebrow: "Knowledge. Solutions. Trust.",
      titleLines: ["Decisioni migliori", "nel commercio", "internazionale."],
      sub: "LB Trade Advisory accompagna le imprese nelle esportazioni e importazioni: conoscenza, strategia ed esecuzione per trasformare la complessità del commercio internazionale in vantaggio competitivo.",
      ctaPrimary: "Parliamone",
      ctaSecondary: "Esplora gli Insights",
      scrollHint: "Scorri",
      marquee: ["Incoterms 2020", "Dogane e dazi", "Logistica globale", "Trade compliance", "Mercati esteri", "Lettere di credito", "Catene di fornitura", "Export management"],
      pillarsEyebrow: "I nostri pilastri",
      pillarsTitle: ["Tre principi.", "Uno standard."],
      pillars: [
        { num: "01", label: "KNOWLEDGE", title: "Conoscenza", text: "Aggiornamento continuo su normative, Incoterms, dogane e logistica: la base per decisioni consapevoli e difendibili." },
        { num: "02", label: "SOLUTIONS", title: "Soluzioni", text: "Strategie operative su misura per ogni mercato, canale e catena di fornitura: dal preventivo alla consegna." },
        { num: "03", label: "TRUST", title: "Fiducia", text: "Un partner di lungo periodo, discreto e affidabile, che porta chiarezza quando la decisione conta." }
      ],
      aboutEyebrow: "Chi siamo",
      aboutTitle: ["Dalla complessità", "alla decisione."],
      aboutText: "LB Trade Advisory nasce per rendere il commercio internazionale più comprensibile e governabile. Lavoriamo al fianco delle imprese su contract, dogane, logistica e mercati esteri, con un unico standard: decisioni chiare, eseguite bene.",
      aboutList: ["Incoterms e contrattistica", "Dogane e compliance", "Logistica e spedizioni", "Sviluppo mercati esteri"],
      aboutLink: "Scopri di più",
      methodEyebrow: "Il metodo LB",
      methodTitle: ["Cinque passi,", "una direzione."],
      knowledgeEyebrow: "Knowledge Center",
      knowledgeTitle: ["Guide e analisi", "pratiche."],
      knowledgeLink: "Vai al Knowledge Center",
      closingTitle: ["Quando la decisione conta,", "conta la chiarezza."],
      closingNote: "Clarity Creates Confidence.",
      closingCta: "Parliamone"
    },
    en: {
      eyebrow: "Knowledge. Solutions. Trust.",
      titleLines: ["Better decisions", "in international", "trade."],
      sub: "LB Trade Advisory supports companies with exports and imports: knowledge, strategy and execution to turn the complexity of international trade into competitive advantage.",
      ctaPrimary: "Let's talk",
      ctaSecondary: "Explore Insights",
      scrollHint: "Scroll",
      marquee: ["Incoterms 2020", "Customs & duties", "Global logistics", "Trade compliance", "Foreign markets", "Letters of credit", "Supply chains", "Export management"],
      pillarsEyebrow: "Our pillars",
      pillarsTitle: ["Three principles.", "One standard."],
      pillars: [
        { num: "01", label: "KNOWLEDGE", title: "Knowledge", text: "Continuous updates on regulations, Incoterms, customs and logistics: the foundation for informed, defensible decisions." },
        { num: "02", label: "SOLUTIONS", title: "Solutions", text: "Tailored operating strategies for every market, channel and supply chain: from quotation to delivery." },
        { num: "03", label: "TRUST", title: "Trust", text: "A long-term partner, discreet and reliable, bringing clarity when the decision matters." }
      ],
      aboutEyebrow: "About us",
      aboutTitle: ["From complexity", "to decision."],
      aboutText: "LB Trade Advisory exists to make international trade easier to understand and govern. We work alongside companies on contracts, customs, logistics and foreign markets, with one standard: clear decisions, executed well.",
      aboutList: ["Incoterms and contracts", "Customs and compliance", "Logistics and shipments", "Foreign market development"],
      aboutLink: "Discover more",
      methodEyebrow: "The LB Method",
      methodTitle: ["Five steps,", "one direction."],
      knowledgeEyebrow: "Knowledge Center",
      knowledgeTitle: ["Practical guides", "and analysis."],
      knowledgeLink: "Go to the Knowledge Center",
      closingTitle: ["When the decision matters,", "clarity matters."],
      closingNote: "Clarity Creates Confidence.",
      closingCta: "Let's talk"
    }
  },

  method: {
    it: {
      steps: [
        { t: "Comprendere", d: "Ascoltiamo il contesto: prodotto, mercato, obiettivi e vincoli reali." },
        { t: "Valutare", d: "Analizziamo rischi, costi e alternative con dati e normativa aggiornata." },
        { t: "Decidere", d: "Indichiamo la strada con opzioni chiare, vantaggi e conseguenze." },
        { t: "Eseguire", d: "Supportiamo documenti, spedizioni e pratiche fino all'arrivo a destinazione." },
        { t: "Migliorare", d: "Rileggiamo i risultati e rafforziamo processi, tempi e margini." }
      ]
    },
    en: {
      steps: [
        { t: "Understand", d: "We listen to the context: product, market, goals and real constraints." },
        { t: "Evaluate", d: "We assess risks, costs and alternatives with data and updated regulation." },
        { t: "Decide", d: "We recommend the way forward with clear options, trade-offs and consequences." },
        { t: "Execute", d: "We support documents, shipments and filings until goods reach destination." },
        { t: "Improve", d: "We review results and strengthen processes, lead times and margins." }
      ]
    }
  },

  about: {
    it: {
      eyebrow: "About & Advisory",
      title: ["Esperienza internazionale,", "metodo unico."],
      sub: "Consulenza import-export per imprese che vogliono decisioni chiare nei mercati internazionali.",
      storyEyebrow: "La nostra storia",
      storyTitle: "Nata dal terreno, costruita sul metodo",
      storyP1: "LB Trade Advisory nasce da un'osservazione semplice: la maggior parte degli errori nel commercio internazionale non nasce dalla scarsa volontà, ma dalla scarsa chiarezza. Termini contrattuali sbagliati, documenti incompleti, costi nascosti che emergono troppo tardi.",
      storyP2: "Lavoriamo con imprese che esportano e importano, accompagnandole in ogni fase: dalla scelta dell'Incoterm alla gestione doganale, dalla negoziazione con i vettori allo sviluppo di nuovi mercati. Un rapporto diretto, riservato, di lungo periodo.",
      advisoryEyebrow: "Il nostro approccio",
      advisoryTitle: "Consulenza che arriva fino all'esecuzione",
      advisoryText: "Non ci limitiamo a consigliare: restiamo al fianco dell'impresa fino a quando la decisione non è eseguita. Ogni incarico parte dai dati e arriva ai risultati.",
      services: [
        {
          t: "Analisi di mercato", d: "Valutazione di potenziale, concorrenza e vie d'ingresso nei mercati esteri.",
          ideal: "Ideale per: aziende che valutano l'ingresso in un nuovo mercato estero.",
          bullets: [
            "Valutazione di domanda, prezzi e concorrenza nei mercati target",
            "Mappatura dei canali distributivi e dei partner locali",
            "Scelta della via d'ingresso: diretta, distributore, agente o e-commerce",
            "Piano di ingresso con costi, tempi e rischi stimati"
          ]
        },
        {
          t: "Incoterms e contrattistica", d: "Scelta dei termini di consegna, revisione di contratti e clausole di protezione.",
          ideal: "Ideale per: chi firma contratti di vendita e acquisto internazionale.",
          bullets: [
            "Scelta del termine di consegna più sicuro per il tuo flusso (da EXW a DDP)",
            "Revisione di contratti di vendita e clausole di protezione",
            "Preventivi senza ambiguità: prezzo e Incoterm sempre insieme",
            "Documenti che difendono la tua posizione in caso di contestazioni"
          ]
        },
        {
          t: "Dogane e compliance", d: "Classificazione, origine preferenziale, adempimenti e gestione dei dazi.",
          ideal: "Ideale per: chi importa o esporta regolarmente e vuole zero sorprese.",
          bullets: [
            "Classificazione doganale corretta: codici HS, note di sezione e di capitolo",
            "Origine preferenziale: certificati, dichiarazioni e dossier a prova di controllo",
            "Licenze, adempimenti e misure restrittive per prodotto e paese",
            "Ottimizzazione dei dazi e gestione delle rettifiche doganali"
          ]
        },
        {
          t: "Logistica e spedizioni", d: "Pianificazione rotte, selezione vettori, ottimizzazione dei costi di trasporto.",
          ideal: "Ideale per: chi vuole spedizioni puntuali senza costi a sorpresa.",
          bullets: [
            "Pianificazione delle rotte e selezione dei vettori giusti",
            "Negoziazione delle tariffe e ottimizzazione dei costi di trasporto",
            "Assicurazioni cargo adeguate al valore reale della merce",
            "Gestione dei tempi: lead time, demurrage e scadenze contrattuali"
          ]
        },
        {
          t: "Gestione documentale", d: "Documenti di trasporto, certificati e pratiche, sempre pronti e coerenti.",
          ideal: "Ideale per: chi vuole documenti bloccati in dogana solo al passato.",
          bullets: [
            "Documenti di trasporto, fatture commerciali e packing list coerenti tra loro",
            "Certificati di origine, sanitari e di conformità sempre pronti",
            "Pratiche doganali complete al primo giro, senza rilanci",
            "Archivio ordinato e consultabile per ogni controllo o audit"
          ]
        }
      ],
      valuesEyebrow: "I nostri valori",
      valuesTitle: ["Quattro principi,", "nessuna eccezione."],
      values: [
        { t: "Chiarezza", d: "Ogni consiglio è comprensibile, motivato e verificabile. Nelle due lingue del commercio: fattualità e precisione." },
        { t: "Competenza", d: "Conoscenza normativa e operativa aggiornata ogni giorno, applicata al caso concreto." },
        { t: "Riservatezza", d: "Ciò che ci viene affidato resta tra noi: progetti, margini, mercati e strategie." },
        { t: "Responsabilità", d: "Portiamo le decisioni fino all'esecuzione e rispondiamo dei risultati." }
      ],
      ctaTitle: ["Ogni decisione inizia con una conversazione."],
      ctaButton: "Parliamone",
      serviceCta: "Parliamone di questo servizio"
    },
    en: {
      eyebrow: "About & Advisory",
      title: ["International experience,", "one method."],
      sub: "Import-export advisory for companies that want clear decisions in international markets.",
      storyEyebrow: "Our story",
      storyTitle: "Born on the ground, built on method",
      storyP1: "LB Trade Advisory was born from a simple observation: most mistakes in international trade do not come from lack of will, but from lack of clarity. Wrong contractual terms, incomplete documents, hidden costs emerging too late.",
      storyP2: "We work with companies that export and import, supporting them at every stage: from choosing the Incoterm to customs handling, from negotiating with carriers to developing new markets. A direct, confidential, long-term relationship.",
      advisoryEyebrow: "Our approach",
      advisoryTitle: "Advisory that follows through to execution",
      advisoryText: "We do not stop at advising: we stand beside the company until the decision is executed. Every engagement starts from data and ends with results.",
      services: [
        {
          t: "Market analysis", d: "Assessment of potential, competition and entry routes in foreign markets.",
          ideal: "Ideal for: companies evaluating entry into a new foreign market.",
          bullets: [
            "Assessment of demand, pricing and competition in target markets",
            "Mapping of distribution channels and local partners",
            "Choosing the entry route: direct, distributor, agent or e-commerce",
            "An entry plan with estimated costs, timing and risks"
          ]
        },
        {
          t: "Incoterms and contracts", d: "Choice of delivery terms, contract review and protective clauses.",
          ideal: "Ideal for: anyone signing international sales and purchase contracts.",
          bullets: [
            "Choosing the safest delivery term for your flow (from EXW to DDP)",
            "Review of sales contracts and protective clauses",
            "Quotes without ambiguity: price and Incoterm always together",
            "Documents that defend your position in case of disputes"
          ]
        },
        {
          t: "Customs and compliance", d: "Classification, preferential origin, requirements and duty management.",
          ideal: "Ideal for: regular importers and exporters who want zero surprises.",
          bullets: [
            "Correct customs classification: HS codes, section and chapter notes",
            "Preferential origin: certificates, declarations and audit-proof files",
            "Licences, requirements and restrictive measures by product and country",
            "Duty optimization and handling of customs adjustments"
          ]
        },
        {
          t: "Logistics and shipments", d: "Route planning, carrier selection, transport cost optimization.",
          ideal: "Ideal for: companies that want on-time shipments with no hidden costs.",
          bullets: [
            "Route planning and selection of the right carriers",
            "Tariff negotiation and transport cost optimization",
            "Cargo insurance adequate to the real value of the goods",
            "Time management: lead times, demurrage and contractual deadlines"
          ]
        },
        {
          t: "Document management", d: "Transport documents, certificates and filings, always ready and consistent.",
          ideal: "Ideal for: companies that want documents stuck at customs only in their past.",
          bullets: [
            "Transport documents, commercial invoices and packing lists consistent with each other",
            "Origin, sanitary and conformity certificates always ready",
            "Customs filings complete at first pass, with no back-and-forth",
            "An ordered, retrievable archive for every control or audit"
          ]
        }
      ],
      valuesEyebrow: "Our values",
      valuesTitle: ["Four principles,", "no exceptions."],
      values: [
        { t: "Clarity", d: "Every recommendation is understandable, justified and verifiable. In the two languages of trade: facts and precision." },
        { t: "Expertise", d: "Regulatory and operational knowledge updated daily, applied to the concrete case." },
        { t: "Confidentiality", d: "What is entrusted to us stays between us: projects, margins, markets and strategies." },
        { t: "Responsibility", d: "We carry decisions through to execution and answer for the results." }
      ],
      ctaTitle: ["Every decision starts with a conversation."],
      ctaButton: "Let's talk",
      serviceCta: "Let's talk about this service"
    }
  },

  contact: {
    it: {
      title: ["Parliamone."],
      sub: "Raccontaci il tuo progetto, il tuo dubbio o la tua emergenza: ti risponderemo con concretezza, in breve tempo.",
      stepsTitle: "Cosa succede dopo",
      steps: [
        { t: "Leggiamo", d: "Ogni messaggio viene letto da un consulente, non da un robot." },
        { t: "Rispondiamo", d: "Ti ricontattiamo in breve tempo con prime indicazioni utili." },
        { t: "Definiamo", d: "Se servono approfondimenti, fissiamo una call o un incontro." }
      ],
      name: "Nome e cognome",
      namePh: "Il tuo nome",
      email: "Email",
      emailPh: "nome@azienda.com",
      company: "Azienda (opzionale)",
      companyPh: "Nome della tua azienda",
      message: "Messaggio",
      messagePh: "Raccontaci di cosa hai bisogno…",
      send: "Invia messaggio",
      sending: "Invio in corso…",
      success: "Messaggio inviato. Grazie — ti ricontatteremo al più presto.",
      successNote: "Il tuo messaggio è stato registrato correttamente.",
      error: "Si è verificato un errore. Riprova tra poco.",
      errName: "Inserisci il tuo nome (minimo 2 caratteri).",
      errEmail: "Inserisci un indirizzo email valido.",
      errMessage: "Scrivi un messaggio di almeno 10 caratteri.",
      followTitle: "Seguici su LinkedIn",
      followText: "Aggiornamenti settimanali su dogane, dazi, Incoterms e logistica."
    },
    en: {
      title: ["Let's talk."],
      sub: "Tell us about your project, your doubt or your emergency: we will reply with substance, in a short time.",
      stepsTitle: "What happens next",
      steps: [
        { t: "We read", d: "Every message is read by a consultant, not a robot." },
        { t: "We reply", d: "We get back to you quickly with useful first indications." },
        { t: "We define", d: "If deeper analysis is needed, we schedule a call or a meeting." }
      ],
      name: "Full name",
      namePh: "Your name",
      email: "Email",
      emailPh: "name@company.com",
      company: "Company (optional)",
      companyPh: "Your company name",
      message: "Message",
      messagePh: "Tell us what you need…",
      send: "Send message",
      sending: "Sending…",
      success: "Message sent. Thank you — we will get back to you soon.",
      successNote: "Your message has been recorded correctly.",
      error: "Something went wrong. Please try again shortly.",
      errName: "Please enter your name (at least 2 characters).",
      errEmail: "Please enter a valid email address.",
      errMessage: "Please write a message of at least 10 characters.",
      followTitle: "Follow us on LinkedIn",
      followText: "Weekly updates on customs, duties, Incoterms and logistics."
    }
  },

  footer: {
    it: { tagline: "Knowledge. Solutions. Trust.", note: "Clarity Creates Confidence.", rights: "Tutti i diritti riservati.", reserved: "Area riservata", categories: "Categorie", freeGuide: "Guida gratuita: Incoterms 2020", follow: "Seguici su LinkedIn" },
    en: { tagline: "Knowledge. Solutions. Trust.", note: "Clarity Creates Confidence.", rights: "All rights reserved.", reserved: "Reserved area", categories: "Categories", freeGuide: "Free guide: Incoterms 2020", follow: "Follow us on LinkedIn" }
  },

  admin: {
    it: {
      loginTitle: "Area riservata",
      loginSub: "Accesso riservato all'amministrazione del sito.",
      email: "Email",
      password: "Password",
      login: "Accedi",
      loggingIn: "Accesso…",
      loginError: "Credenziali non valide o account bloccato temporaneamente.",
      logout: "Esci",
      tabs: { articles: "Articoli", drafts: "Bozze AI", messages: "Messaggi", stats: "Statistiche", newsletter: "Newsletter", linkedin: "LinkedIn" },
      newArticle: "Nuovo articolo",
      emptyArticles: "Nessun articolo. Creane uno nuovo.",
      statusPublished: "Pubblicato",
      statusDraft: "Bozza",
      edit: "Modifica",
      publish: "Pubblica",
      unpublish: "Ritira",
      remove: "Elimina",
      confirmDelete: "Eliminare definitivamente questo articolo?",
      view: "Vedi",
      editorTitle: { create: "Nuovo articolo", edit: "Modifica articolo" },
      fieldTitleIt: "Titolo (IT)", fieldTitleEn: "Titolo (EN)",
      fieldExcerptIt: "Estratto (IT)", fieldExcerptEn: "Estratto (EN)",
      fieldBodyIt: "Testo (IT)", fieldBodyEn: "Testo (EN)",
      fieldBodyHint: "Paragrafi separati da una riga vuota. Una riga che inizia con '## ' diventa un sottotitolo.",
      section: "Sezione", sectionKnowledge: "Knowledge Center", sectionInsights: "Insights",
      category: "Categoria",
      save: "Salva bozza",
      savePublish: "Salva e pubblica",
      cancel: "Annulla",
      saved: "Articolo salvato",
      published: "Articolo pubblicato",
      unpublished: "Articolo ritirato: ora è in bozza",
      deleted: "Articolo eliminato",
      aiTitle: "Assistente AI editoriale",
      aiSub: "Claude propone bozze di articoli sul commercio internazionale, in italiano e in inglese. Le bozze restano in attesa finché non le approvi: nessuna pubblicazione automatica.",
      topicPh: "Tema (opzionale) — es. Incoterms: quando usare FCA",
      generate: "Genera bozza",
      generating: "Generazione in corso… (possono servire fino a un minuto)",
      aiEmpty: "Nessuna bozza in attesa di revisione.",
      aiUse: "Converti in articolo",
      aiDiscard: "Scarta",
      aiAccepted: "Bozza convertita: ora puoi modificarla e pubblicarla.",
      aiDiscarded: "Bozza scartata",
      aiError: "Generazione non riuscita. Riprova.",
      draftsWaiting: "bozze in attesa",
      messagesEmpty: "Nessun messaggio ricevuto.",
      from: "Da",
      markRead: "Segna come letta",
      new: "Nuova",
      msgRead: "Messaggio segnato come letto",
      visualBtn: "Genera visual",
      socialBtn: "Post LinkedIn", socialTitle: "Post LinkedIn pronto da incollare", socialHint: "Generato dall'assistente AI dall'articolo pubblico. Copia e incolla direttamente sulla pagina aziendale LinkedIn (linkedin.com/company/lb-trade-advisory), aggiungendo il link se vuoi.", postCopy: "Copia il post", postCopied: "Post copiato!", socialError: "Generazione non riuscita, riprova", close: "Chiudi",
      visualDone: "Visual generato e collegato all'articolo",
      visualError: "Generazione visual non riuscita, riprova"
    },
    en: {
      loginTitle: "Reserved area",
      loginSub: "Access restricted to site administration.",
      email: "Email",
      password: "Password",
      login: "Sign in",
      loggingIn: "Signing in…",
      loginError: "Invalid credentials or account temporarily locked.",
      logout: "Sign out",
      tabs: { articles: "Articles", drafts: "AI drafts", messages: "Messages", stats: "Stats", newsletter: "Newsletter", linkedin: "LinkedIn" },
      newArticle: "New article",
      emptyArticles: "No articles yet. Create a new one.",
      statusPublished: "Published",
      statusDraft: "Draft",
      edit: "Edit",
      publish: "Publish",
      unpublish: "Unpublish",
      remove: "Delete",
      confirmDelete: "Permanently delete this article?",
      view: "View",
      editorTitle: { create: "New article", edit: "Edit article" },
      fieldTitleIt: "Title (IT)", fieldTitleEn: "Title (EN)",
      fieldExcerptIt: "Excerpt (IT)", fieldExcerptEn: "Excerpt (EN)",
      fieldBodyIt: "Body (IT)", fieldBodyEn: "Body (EN)",
      fieldBodyHint: "Paragraphs separated by an empty line. A line starting with '## ' becomes a subheading.",
      section: "Section", sectionKnowledge: "Knowledge Center", sectionInsights: "Insights",
      category: "Category",
      save: "Save draft",
      savePublish: "Save and publish",
      cancel: "Cancel",
      saved: "Article saved",
      published: "Article published",
      unpublished: "Article unpublished: it is now a draft",
      deleted: "Article deleted",
      aiTitle: "AI editorial assistant",
      aiSub: "Claude proposes article drafts on international trade, in Italian and English. Drafts stay pending until you approve them: no automatic publishing.",
      topicPh: "Topic (optional) — e.g. Incoterms: when to use FCA",
      generate: "Generate draft",
      generating: "Generating… (this can take up to a minute)",
      aiEmpty: "No drafts waiting for review.",
      aiUse: "Convert to article",
      aiDiscard: "Discard",
      aiAccepted: "Draft converted: you can now edit and publish it.",
      aiDiscarded: "Draft discarded",
      aiError: "Generation failed. Please try again.",
      draftsWaiting: "drafts waiting",
      messagesEmpty: "No messages received.",
      from: "From",
      markRead: "Mark as read",
      new: "New",
      msgRead: "Message marked as read",
      visualBtn: "Generate visual",
      socialBtn: "LinkedIn post", socialTitle: "LinkedIn post ready to paste", socialHint: "Generated by the AI assistant from the published article. Copy and paste it directly on your LinkedIn company page (linkedin.com/company/lb-trade-advisory), adding the link if you like.", postCopy: "Copy post", postCopied: "Post copied!", socialError: "Generation failed, try again", close: "Close",
      visualDone: "Visual generated and linked to the article",
      visualError: "Visual generation failed, please try again"
    }
  },

  notfound: {
    it: { title: "Pagina non trovata", sub: "La rotta che cerchi non esiste o è stata spostata.", cta: "Torna alla home" },
    en: { title: "Page not found", sub: "The route you are looking for does not exist or has moved.", cta: "Back to home" }
  }
};
